// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailCompleteButton_container__2PwwE","text":"OrderDetailCompleteButton_text__1yJ5Y","text-ltr":"OrderDetailCompleteButton_text-ltr__2Zgww"};